export default __webpack_public_path__ + "static/media/Photographs2.37d19f74.png";